import React from 'react'
import { APP_ROUTES } from "../../constants/approutes";
import OurLayouts from "../layout/index";
import UserProfile from './userProfile.jsx';
import AdminProfile from './AdminProfile.jsx';

const MyProfileIndex = () => {
    return (
        <OurLayouts>
            <div>
                <UserProfile />
                <div className="mt-6"></div>
  
            </div>
        </OurLayouts>
    )
}

export default MyProfileIndex